(() => {
  if (window.__brandDiscountOwnPriceInit) return;
  window.__brandDiscountOwnPriceInit = true;

  const CONFIG_ID = "BrandDiscountConfig";
  const OUT_ID = "BrandDiscountedPrice";

  function cfg() { return document.getElementById(CONFIG_ID); }
  function outEl() { return document.getElementById(OUT_ID); }

  function parseMoneyToCents(text) {
    if (!text) return null;
    let s = String(text).trim().replace(/[^\d.,-]/g, "");
    if (!s) return null;

    const lastDot = s.lastIndexOf(".");
    const lastComma = s.lastIndexOf(",");
    let decSep = null;

    if (lastDot !== -1 && lastComma !== -1) decSep = lastDot > lastComma ? "." : ",";
    else if (lastComma !== -1) decSep = ((s.length - lastComma - 1) <= 2) ? "," : null;
    else if (lastDot !== -1) decSep = ((s.length - lastDot - 1) <= 2) ? "." : null;

    if (decSep) {
      const parts = s.split(decSep);
      const intPart = parts[0].replace(/[.,]/g, "");
      const fracPart = (parts[1] || "").replace(/[^\d]/g, "");
      s = intPart + "." + fracPart;
    } else {
      s = s.replace(/[.,]/g, "");
    }

    const num = Number(s);
    return Number.isFinite(num) ? Math.round(num * 100) : null;
  }

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === "function") return window.theme.formatMoney(cents);
    if (window.Shopify && typeof Shopify.formatMoney === "function" && Shopify.money_format) return Shopify.formatMoney(cents, Shopify.money_format);
    try {
      const currency =
        (window.Shopify && Shopify.currency && Shopify.currency.active) ||
        document.documentElement.getAttribute("data-currency") ||
        "USD";
      return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function findAppPriceEl() {
    // Read from the app-owned element (even if hidden/clone). Prefer the one with the tpo class if present.
    const tpo = document.querySelector('[id^="ProductPrice-"].tpo_product_price');
    if (tpo) return tpo;

    const all = document.querySelectorAll('[id^="ProductPrice-"]');
    return all.length ? all[0] : null;
  }

  let observer = null;
  let stableTimer = null;
  let lastRawSeen = null;

  function updateFromAppPrice() {
    const cfgEl = cfg();
    const out = outEl();
    const appPrice = findAppPriceEl();
    if (!cfgEl || !out || !appPrice) return;

    const pct = parseFloat(cfgEl.dataset.discount || "0");
    if (!pct) return;

    const raw = parseMoneyToCents(appPrice.textContent);
    if (raw == null) return;

    // Debounce: only update after raw settles
    lastRawSeen = raw;
    if (stableTimer) clearTimeout(stableTimer);
    stableTimer = setTimeout(() => {
      const factor = 1 - pct / 100;
      const discounted = Math.round(lastRawSeen * factor);
      out.textContent = formatMoney(discounted);
    }, 120);
  }

  function startObserver() {
    const appPrice = findAppPriceEl();
    if (!appPrice) return;

    if (observer) observer.disconnect();
    observer = new MutationObserver(updateFromAppPrice);

    observer.observe(appPrice, {
      childList: true,
      characterData: true,
      subtree: true
    });

    // Run once
    updateFromAppPrice();
  }

  function init() {
    if (!cfg() || !outEl()) return;
    startObserver();

    // If the app replaces the node, watch the document for a new one and rebind.
    const rebinder = new MutationObserver(() => {
      const appPrice = findAppPriceEl();
      if (appPrice && (!observer || observer.takeRecords)) {
        // attempt to rebind safely
        startObserver();
      }
    });

    rebinder.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();